export default "__VITE_ASSET__BWPPoQMI__"